<template>
  <div class="card_info">
    <div class="assessment_header">个人信息</div>
    <div
      class="card_list"
      v-for="(element, key, index) in baseInfo.info"
      :key="index"
    >
      <div class="title">{{ itemInfo[key] }}</div>
      <div class="card_row">
        <div class="card_item" v-for="item in element" :key="item.id">
          <div class="label">{{ item["label"] }}</div>
          <div class="val">{{ item.val || "--" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      itemInfo: {
        base_info: "基础信息",
        family_info: "家庭信息",
        body_info: "身体信息",
        other: "其他信息",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.card_info {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    font-family: SysFontM;
    font-size: 16px;
    padding-bottom: 16px;
    padding-top: 24px;
    color: #3a3a3a;
    position: relative;
    padding-left: 12px;
    &::after {
      content: "";
      width: 3px;
      height: 24px;
      background-image: url("~@/assets/images/cfa/line.svg");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      position: absolute;
      left: 0;
      top: 20px;
    }
  }
  .card_list {
    width: 100%;
  }
  .card_row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    font-family: "SysFontR";
    .card_item {
      width: 25%;
      height: 90px;
    }

    .label {
      font-size: 12px;
      line-height: 17px;
      color: $base-font-tip;
      margin-bottom: 4px;
    }

    .val {
      margin-top: 4px;
      font-size: 14px;
      line-height: 1.2;
      color: $base-font-major;
      width: 90%;
      height: 68px;
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
}
.assessment_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 57px;
  border-bottom: 1px solid #f3f3f3;
  padding-top: 6px;
  font-size: 18px;
  font-weight: 600;
}
</style>
